module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/hip_joint-c81925feba97a8374870945373c0cf96.png";